/**
 * UserRegisterPresenter
 * --
 */
import React from 'react';
import { Content, Title, Row, Col, InputFormTable } from 'components';
import { Select, Input, Button, Checkbox } from 'antd';

const UserRegisterPresenter = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    subTitle: {
      fontSize: 17,
      fontWeight: 500,
      lineHeight: '141%',
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const form1 = [
    {
      label: '회원등급',
      required: true,
      form: [
        {
          input: (
            <Select
              size="large"
              options={[
                { label: 'VV', value: 'VVIP' },
                { label: 'V', value: 'VIP' },
                { label: 'G', value: 'GOLD' },
                { label: 'S', value: 'SILVER' },
                { label: 'W', value: 'WELCOME' },
              ]}
              placeholder="등급을 선택하세요."
            />
          ),
        },
      ],
    },
    {
      label: '이름',
      required: true,
      form: [
        {
          input: <Input size="large" placeholder="이름 입력" />,
          count: true,
          maxLength: 30,
        },
      ],
    },
    {
      label: '아이디',
      required: true,
      form: [
        {
          input: <Input size="large" placeholder="아이디 입력" />,
          count: true,
          maxLength: 30,
        },
        { input: <Button size="large">중복확인</Button> },
      ],
    },
    {
      label: '비밀번호',
      required: true,
      form: [
        { input: <Input size="large" placeholder="비밀번호 입력" /> },
        { input: <Input size="large" placeholder="비밀번호 확인" /> },
      ],
      message: (
        <p>
          * 비밀번호는 영문,숫자, 특수문자 모두 조합하여 8~20자리로 입력하셔야
          합니다.
          <br />
          (10자리 이상이면 2종류 이상 조합, 미만이면 3종류 모두 조합)
        </p>
      ),
    },
    {
      label: '이메일',
      required: true,
      form: [
        {
          input: (
            <>
              <Input size="large" placeholder="이메일 입력" />
              <p>@</p>
              <Input size="large" placeholder="naver.com" />
            </>
          ),
        },
        { input: <Button size="large">중복확인</Button> },
        { input: <Checkbox size="large">이메일 수신 동의</Checkbox> },
      ],
    },
    {
      label: '휴대폰번호',
      required: true,
      form: [
        {
          input: <Input size="large" placeholder="휴대폰번호 '-'없이 입력" />,
        },
        { input: <Checkbox size="large">SMS 수신 동의</Checkbox> },
      ],
    },
    {
      label: '주소',
      required: true,
      direction: 'column',
      form: [
        {
          input: (
            <>
              <Input size="large" placeholder="우편번호" />
              <Button size="large">주소찾기</Button>
            </>
          ),
        },
        {
          input: (
            <>
              <Input
                size="large"
                placeholder="도로명 주소"
                style={{ width: 295 }}
              />
              <Input
                size="large"
                placeholder="상세주소"
                style={{ width: 295 }}
              />
            </>
          ),
        },
      ],
    },
  ];
  const form2 = [
    {
      label: '회원정보 관련 메모',
      form: [
        {
          input: <Input.TextArea style={{ height: 160, width: '100%' }} />,
          fullscreen: true,
        },
      ],
    },
  ];
  const form3 = [
    {
      label: '개인정보 수집/이용(필수)',
      required: true,
      form: [{ input: <Checkbox size="large">이메일 수신 동의</Checkbox> }],
    },
    {
      label: '만 14세 이상 가입 동의(필수)',
      required: true,
      form: [{ input: <Checkbox size="large">이메일 수신 동의</Checkbox> }],
    },
  ];

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title style={{ ...styles.title }}>회원 등록</Title>

          {/* 기본정보 */}
          <Content
            maxWidth={'100%'}
            padding={20}
            borderRadius={4}
            style={{ marginBottom: 40 }}
          >
            <Title style={{ ...styles.subTitle }}>기본 정보</Title>
            <InputFormTable form={form1} />
          </Content>
          {/* 기본정보 끝 */}

          {/* 부가 정보 */}
          <Content
            maxWidth={'100%'}
            padding={20}
            borderRadius={4}
            style={{ marginBottom: 40 }}
          >
            <Title style={{ ...styles.subTitle }}>부가 정보</Title>
            <InputFormTable form={form2} />
          </Content>
          {/* 부가 정보 끝 */}

          {/* 개인정보 수집/이용 동의 */}
          <Content
            maxWidth={'100%'}
            padding={20}
            borderRadius={4}
            style={{ marginBottom: 40 }}
          >
            <Title style={{ ...styles.subTitle }}>
              개인정보 수집/이용 동의
            </Title>
            <InputFormTable form={form3} />
          </Content>
          {/* 개인정보 수집/이용 동의 끝 */}

          {/* 버튼 */}
          <Content maxWidth={'100%'} backgroundColor={'none'}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Button
                size="large"
                style={{
                  ...styles.button,
                  background: 'var(--primary-color)',
                  color: '#FFFFFF',
                }}
              >
                저장
              </Button>
              <Button size="large" style={{ ...styles.button }}>
                취소
              </Button>
            </div>
          </Content>
          {/* 버튼 끝 */}
        </Col>
      </Row>
    </Content>
  );
};

export default UserRegisterPresenter;
